import React, { useEffect } from 'react';
import moment from 'moment';
import store from '../../index';
import DateTime from '_class/DateTime';
import { FormSpy, useForm } from 'react-final-form';
import { throttle } from 'helpers/content';
import { getBasedOnLastModified, saveWithExpirationAndLastModified, getObjectExpiration } from 'helpers/localstorage';
var updateLocalValues = throttle(function (_ref, name) {
  var values = _ref.values;
  saveWithExpirationAndLastModified(name + '-values', JSON.stringify(values), moment().add(48, 'hours'));
}, 1000);

var PersistentFormListener = function PersistentFormListener(_ref2) {
  var name = _ref2.name,
      initialValues = _ref2.initialValues,
      lastModifiedUTC = _ref2.lastModifiedUTC,
      addTimeStampedToast = _ref2.addTimeStampedToast;
  var form = useForm();

  if (form.getState().submitSucceeded && !form.getState().dirtySinceLastSubmit) {
    localStorage.removeItem(name + '-values');
  }

  useEffect(function () {
    if (lastModifiedUTC != null && getBasedOnLastModified(name + '-values', lastModifiedUTC) != null) {
      var storedValues = JSON.parse(getBasedOnLastModified(name + '-values', lastModifiedUTC));

      if (storedValues.hasOwnProperty('status')) {
        delete storedValues['status'];
      }

      if (initialValues.hasOwnProperty('status')) {
        delete initialValues['status'];
      }

      if (JSON.stringify(initialValues) != JSON.stringify(storedValues)) {
        var values = storedValues;
        setTimeout(function () {
          form.batch(function () {
            Object.keys(values).forEach(function (field) {
              var value = values[field];

              if (value == null || value == "") {
                return false;
              }

              form.change(field, values[field]);
            });
          });
        }, 50);
        addTimeStampedToast('There are changes to the form that have not been saved. In order not to lose the changes, you must resave the form at the latest:', moment.utc(getObjectExpiration(name + '-values')).local().format('Do MMMM HH:mm'), 'error');
      }
    }

    return function () {
      if (!form.getState().submitFailed) {
        localStorage.removeItem(name + '-values');
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(FormSpy, {
    onChange: function onChange(subscription) {
      if (!form.getState().dirty && !form.getState().dirtySinceLastSubmit) {
        // Dont update values in localStorage if form isnt touched (init)
        return false;
      }

      updateLocalValues(subscription, name);
    },
    subscription: {
      values: true
    }
  });
};

PersistentFormListener.defaultProps = {
  name: 'persisted_form'
};
export default PersistentFormListener;